import { render, staticRenderFns } from "./SettingsPopup.vue?vue&type=template&id=ee8e0882&"
import script from "./SettingsPopup.vue?vue&type=script&lang=js&"
export * from "./SettingsPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports